import InstagramIcon from "@material-ui/icons/Instagram"
import React from "react"
import Link from "next/link"
import { Row, Col } from "react-bootstrap"
import { imageResizer } from "../../../services/utils/imageResizer"
import { slugify } from "../../../services/utils/slugify"
import { HeadingTitle } from "../Layout/HeadingTitle"
import styles from "./GalleryHeader.module.scss"
import classnames from "classnames"

export const GalleryHeader = ({ galleryDetails, onClickContact }) => {
  const initials = galleryDetails.name
    .split(/\s/)
    .reduce((response, word) => (response += word.slice(0, 1)), "")
    .toUpperCase()
    .substring(0, 3)

  const makeContactData = () => {
    const website =
      galleryDetails.website &&
      galleryDetails.website.replace("https://", "").replace("http://", "")
    const contactItems = [
      galleryDetails.phone,
      website && (
        <a
          className="text-decoration-underline"
          href={`http://${website}`}
          target="_blank">
          {website}
        </a>
      ),
      galleryDetails.instagram && (
        <>
          <a
            href={`https://www.instagram.com/${galleryDetails.instagram
              .replace("/", "")
              .trim()}`}
            target="_blank"
            className={styles["gallery-instagram"]}>
            <InstagramIcon style={{ width: 18, fontSize: "18px" }} />
            <span>{galleryDetails.instagram}</span>
          </a>
        </>
      ),
      onClickContact ? (
        <span
          onClick={onClickContact}
          className="text-decoration-underline font-secondary contactBlack cursor-pointer">
          Get in touch
        </span>
      ) : (
        <Link
          href="/galleries/[id]/contact"
          as={`/galleries/${galleryDetails.id}-${slugify(
            galleryDetails.name,
          )}/contact`}
          className="text-decoration-underline font-secondary contactBlack">
          Get in touch
        </Link>
      ),
    ].filter((i) => i)

    const contactItemsDesktop = contactItems
      .reduce((arr, b) => [...arr, b, " · "], [])
      .slice(0, -1)
    const contactItemsMobile = contactItems.map((value, index) => (
      <div key={`contact-item-${index}`} className="my-1">
        {value}
      </div>
    ))

    return (
      <div className={classnames(styles["gallery-links"], "color-gray-light")}>
        {galleryDetails.address && (
          <>
            {galleryDetails.address}
            <br />
          </>
        )}
        <div
          className={classnames(
            styles["contactItemsDesktop"],
            "contactBlack",
            "fw-700",
          )}>
          {contactItemsDesktop}
        </div>
        <div
          className={classnames(
            styles["contactItemsMobile"],
            "contactBlack",
            "fw-700",
          )}>
          {contactItemsMobile}
        </div>
      </div>
    )
  }

  return (
    <Row className={classnames(styles["gallery-header"])}>
      <Col className={classnames(styles["gallery-header-thumbnail"])}>
        <Link href={`/galleries/${galleryDetails.domain}`}>
          {galleryDetails.thumbnail ? (
            <div
              className={styles["gallery-logo"]}
              style={{
                backgroundImage: `url(${imageResizer(
                  galleryDetails.thumbnail,
                  220,
                  220,
                )})`,
              }}
            />
          ) : (
            <div className={classnames(styles["gallery-initials"], "mb-4")}>
              <p className={styles["gallery-inicials"]}>{initials}</p>
            </div>
          )}
        </Link>
      </Col>
      <Col className={classnames(styles["gallery-header-info"])}>
        <HeadingTitle
          title={galleryDetails.name}
          href={`/galleries/${galleryDetails.domain}`}
          to={`/galleries/${galleryDetails.domain}`}>
          {galleryDetails.bio && (
            <div className={styles["gallery-header-bio"]}>
              {galleryDetails.bio}
              <br />
            </div>
          )}
          {makeContactData()}
        </HeadingTitle>
      </Col>
    </Row>
  )
}
